<template>
  <div class="z_detail_vue">
    <div class="z_breadcrumb">
      <div class="z_content">
        <svg-icon className="icon" icon-class="nav_header1" />
        <span>当前位置： </span>
        <span>首页</span>
        <svg-icon className="icon" icon-class="right" />
        <span>竞价大厅</span>
      </div>
    </div>
    <div class="z_detail">
      <div class="z_content" style="padding: 24px 71px">
        <!-- <div class="z_title"></div> -->
        <div class="z_detail_content">
          <z-card
            style="margin-top: 16px; min-height: 692px"
            :titleparam="{
              iconname: 'nav_header4',
              iconclass: 'card-title',
              title: '竞价大厅',
            }"
            :btngroup="btngroupbid"
            @cardbtncallback="biddingCallback"
          >
          <div style="position: absolute;top: 11px;right: 13px;">
          <input
              type="search"
              class="querytext"
              v-model="keyword"
              @keyup.enter = "Query"
              style="outline: unset;"
              placeholder="输入关键字"
            />
            <a class="querybtn search_btn" @click="Query">搜 索</a>
          </div>
            <div style="border-top: 1px solid #e8e8e8">
              <div
                v-if="
                  biddingType === 0 || biddingType === 1 || biddingType === 2
                "
              >
                <div
                  @click="Bullet(item.prjId)"
                  v-for="item in biddingList"
                  :key="item.prjId"
                  class="bid-card"
                >
                  <div title="立即报价" class="bid-card-container">
                    <div class="bid-card-head">
                      <div class="bid-card-prjname">{{ item.prjName }}</div>
                      <div class="bid-card-alert" style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
                        <svg-icon
                          style="margin-left: 12px"
                          className="bid-card-svg"
                          icon-class="jjgs"
                        />
                        {{ item.yzCompanyName }}
                      </div>
                    </div>
                    <div class="bid-card-body">
                      <!-- {{ item.prjContent }} -->
                      <ul>
                        <li>
                          <div>
                            <span class="catalogue">品目分类：</span
                            ><span class="catalogue_span">
                              {{ item.callingName }}
                            </span>
                          </div>
                        </li>
                        <li>
                          <div>
                            <span class="catalogue">项目编号：</span
                            ><span class="catalogue_span">{{
                              item.prjNo
                            }}</span>
                          </div>
                        </li>
                        <li>
                          <div>
                            <span class="catalogue">商务要求：</span>
                            <span class="catalogue_span">{{
                              item.remark
                            }}</span>
                          </div>
                        </li>
                        <li>
                          <div>
                            <span class="catalogue">预算价格：</span
                            ><span class="catalogue_span"
                              >{{ item.basePrice | NumberFormat }} 元</span
                            >
                          </div>
                        </li>
                        <li>
                          <div>
                            <span class="catalogue">发布日期：</span
                            ><span class="catalogue_span"
                              >{{ item.signUpDate | moment_d }}</span
                            >
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div class="bid-card-footer">
                      <div
                        v-if="!getcountdown(item.kbDate).showcountdown||item.state==4"
                        style="
                          text-align: center;
                          color: #f95965;
                          font-weight: bold;
                        "
                      >
                        <span>报价结束</span>
                      </div>
                      <div
                        v-else-if="item.state==6"
                        style="
                          text-align: center;
                          color: #f95965;
                          font-weight: bold;
                        "
                      >
                        <span>已暂停</span>
                      </div>
                      <div
                        v-else
                        class="bid-card-footer-countdown"
                      >
                      <span>报价结束倒计时</span>
                        <span class="footer-time" style="margin-left: 8px">{{
                          getcountdown(item.kbDate).days
                        }}</span>
                        <span>天</span>
                        <span class="footer-time">{{
                          getcountdown(item.kbDate).hours
                        }}</span>
                        <span>时</span>
                        <span class="footer-time">{{
                          getcountdown(item.kbDate).minutes
                        }}</span>
                        <span>分</span>
                      </div>
                    </div>
                    <div
                      v-if="biddingType === 1"
                      :class="
                        item.minFinallyPrice != 0 ? 'bid-card-footer-price' : ''
                      "
                    >
                      <div v-show="item.minFinallyPrice != 0">
                        <div class="price-div">
                          <span style="margin-left: 8px">¥</span>
                          <span class="pricespan"
                            >{{ item.minFinallyPrice | NumberFormat }} 元</span
                          >
                        </div>

                        <div class="skewX">
                          <div>当前最低报价</div>
                        </div>
                      </div>
                    </div>
                    <div v-else class="bid-card-footer-btn">
                      <div v-if="!getcountdown(item.kbDate).showcountdown||item.state==4||item.state==6">
                      <button @click="Bullet(item.prjId)">详情</button>
                      </div>
                      <div v-else>
                        <button @click.stop="Offer(item.prjId)">立即报价</button>
                      </div>
                    </div>
                  </div>
                  <img style="position: absolute;top: 155px;right: 10px;" v-if="!getcountdown(item.kbDate).showcountdown||item.state==4" src="../../assets/status3.png" alt="">
                </div>
              </div>
              <div v-else-if="biddingType === 3">
                <ul class="z-list" style="border-top: 1px solid #e8e8e8">
                  <li v-for="item in biddingResult" :key="item.prjNo">
                    <div class="z-list-title" style="width: auto">
                      <!-- <router-link
                        :to="{
                          name: 'detail',
                          query: { bulletinId: item.autoId },
                        }"
                      > -->
                      <span :class="'z-tag ' + getClass(item.ztbTypeId)"
                        >{{ item.ztbTypeName }}
                      </span>

                      <span
                        v-show="item.prjNo"
                        :title="item.prjNo"
                        style="width: 150px; margin-right: 8px"
                        class="z_list_title_span"
                      >
                        <a @click="Bullet2(item.prjId)">{{ item.prjNo }}</a>
                      </span>
                      <a @click="Bullet2(item.prjId)">
                        <!--  :style="item.prjNo ? 'width: 450px' : ''" -->
                      <span
                        :title="item.prjName"
                        class="z_list_title_span"
                      >
                        {{ item.prjName }}
                      </span>
                      </a>
                      <!-- <span :class="'z-tag ' + getClass(item.ztbTypeId)"
                        >{{ item.ztbTypeName }}
                      </span>
                      <span style="width: 480px" class="z_list_title_span">
                        <a @click="Bullet2(item.prjId)">{{ item.prjName }}</a>
                      </span> -->
                      <!-- <span style="width: 300px" class="z_list_title_span">
                        {{ item.zb_customer }}
                      </span> -->
                      <!-- </router-link> -->
                    </div>
                    <div style="float: right; color: #8c8c8c">
                      <!-- <span style="margin-right: 16px">
                        {{ item.finallyPrice | NumberFormat }}
                      </span> -->
                      <span>
                        {{ item.closeDate | moment_d }}
                      </span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="clear"></div>
          </z-card>
          <a-pagination
            style="text-align: right"
            v-model="current"
            :page-size="pageSize"
            :total="total"
            @change="PageSizeChange"
            show-less-items
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetPurchaseResults, GetBiddingHall } from "@/api/Home";
import ZCard from "@/components/card";
import moment from "moment";
export default {
  data() {
    return {
      biddingType: 0,
      biddingList: [], //竞价采购
      biddingResult: [],
      current: 1,
      pageSize: 12,
      total: 0,
      deptId : this.$route.query.deptId,
      keyword:'',
    };
  },
  components: {
    ZCard,
  },
  computed: {
    btngroupbid() {
      var Array = [
        { key: 1, name: "电子询价", active: true, biddingType: 0 },
        { key: 2, name: "电子竞价", active: false, biddingType: 1 },
        { key: 3, name: "电子比选", active: false, biddingType: 2 },
        { key: 4, name: "竞价采购结果", active: false, biddingType: 3 },
      ];
      let _biddingType = Number(this.$route.query.biddingType);
      //let _deptid = Number(this.$route.query.deptid);
      Array.forEach((item) => {
        item.active = false;
        if (item.biddingType === _biddingType) {
          item.active = true;
        }
      });
      return Array;
    },
  },
  methods: {
    PageSizeChange(page) {
      if (this.biddingType != 3) {
        this.pageSize = 12;
      } else {
        this.pageSize = 15;
      }
      this.current = page;
      const query = this.$route.query;
      var deptId = query.deptId;
      this.GetList(deptId);
    },
    getcountdown(kbDate) {
      //
      var date = moment(kbDate);
      var now = moment();
      let start = moment(new Date()); //获取开始时间
      let end = moment(new Date(kbDate)); //结束时间
      let result = {
        showcountdown: false,
      };
      if (now < date) {
        let diff = end.diff(start); //时间差
        let days = Math.floor(moment.duration(diff).asDays());
        let hours = moment.duration(diff).hours();
        let minutes = moment.duration(diff).minutes();
        result.days = days > 9 ? days : "0" + days;
        result.hours = hours;
        result.minutes = minutes;
        result.showcountdown = true;
        return result;
      } else {
        return result;
      }
    },
    GetList() {
      if (this.biddingType != 3) {
        let param = {};
        param.pageIndex = this.current;
        param.pageSize = this.pageSize;
        param.classID = "22";
        param.deptId = this.deptId;
        if (this.biddingType === 0) {
          param.ztbTypeId = "0207";
        } else if (this.biddingType === 1) {
          param.ztbTypeId = "0208";
        } else if (this.biddingType === 2) {
          param.ztbTypeId = "0210";
        }
        this.biddingList = [];
        GetBiddingHall(param).then((res) => {
          this.total = res.data.total;
          this.biddingList = res.data.projectList;
        });
      } else {
        let _param = {};
        _param.pageIndex = this.current;
        _param.pageSize = this.pageSize;    
        _param.deptId = this.deptId;
        GetPurchaseResults(_param).then((res) => {
          this.total = res.total;
          this.biddingResult = res.data;
        });
      }
    },
    biddingCallback(key, item) {
      if (this.biddingType != 3) {
        this.pageSize = 12;
      } else {
        this.pageSize = 15;
      }
      this.$router.push({
        path: "/biddinglist",
        query: { biddingType: item.biddingType , deptId: this.deptId},
      });
      this.biddingType = item.biddingType;
      this.current = 1;
      if (item.biddingType != 3) {
        let param = {};
        param.pageIndex = this.current;
        param.pageSize = this.pageSize;
        param.classID = "22";
        param.deptId = this.deptId;

        if (item.biddingType === 0) {
          param.ztbTypeId = "0207";
        } else if (item.biddingType === 1) {
          param.ztbTypeId = "0208";
        } else if (item.biddingType === 2) {
          param.ztbTypeId = "0210";
        }
        this.biddingList = [];
        GetBiddingHall(param).then((res) => {
          this.total = res.data.total;
          this.biddingList = res.data.projectList;
        });
      } else {
        let _param = {};
        _param.pageIndex = this.current;
        _param.pageSize = this.pageSize;
        _param.deptId = this.deptId;
        GetPurchaseResults(_param).then((res) => {
          this.total = res.total;
          this.biddingResult = res.data;
        });
      }

      // console.log(item.biddingType);
    },
    Offer(prjId) {
      window.open("http://ygcg.nbcqjy.org:8061/login.html?PrjId="+prjId, "_blank");
    },
    Bullet(prjId) {
      this.$router.push({
        path: "/detail",
        query: { type: 1, prjId: prjId, biddingType:this.biddingType },
      });
      // window.open("http://47.97.190.124:8059/Bulletin/bulletin.html?prjId="+prjId, "_blank");
    },
    Bullet2(prjId) {
      this.$router.push({
        path: "/detail",
        query: { type: 10, prjId: prjId },
      });
      // window.open("http://ygcg.nbcqjy.org:8059/Bulletin/bulletin.html?prjId="+prjId, "_blank");
    },
    getClass(ztbTypeId) {
      if (ztbTypeId === "0208") {
        return "D01";
      } else if (ztbTypeId === "0207") {
        return "D02";
      } else if (ztbTypeId === "0210") {
        return "D03";
      }
    },
    Query(){
      if(this.biddingType != 3){
      let param = {};
        param.pageIndex = this.current;
        param.pageSize = this.pageSize;
        param.classID = "22";
        param.keywords = this.keyword;
        param.deptId = this.deptId;

        if (this.biddingType === 0) {
          param.ztbTypeId = "0207";
        } else if (this.biddingType === 1) {
          param.ztbTypeId = "0208";
        } else if (this.biddingType === 2) {
          param.ztbTypeId = "0210";
        }
        this.biddingList = [];
        GetBiddingHall(param).then((res) => {
          this.total = res.data.total;
          this.biddingList = res.data.projectList;
        });
      }else{
        let _param = {};
        _param.pageIndex = this.current;
        _param.pageSize = this.pageSize;    
        _param.deptId = this.deptId;
        _param.keywords = this.keyword;
        GetPurchaseResults(_param).then((res) => {
          this.total = res.total;
          this.biddingResult = res.data;
        });
      }
    }
  },
  mounted() {
    let _biddingType = Number(this.$route.query.biddingType);
    const query = this.$route.query;
    var deptId = query.deptId;
    let _item = this.btngroupbid.find((a) => a.biddingType === _biddingType);
    this.biddingCallback(0, _item,deptId);
  },
};
</script>

<style scoped>
.bid-card:nth-child(4n) {
  border-right: none;
}
.bid-card:nth-child(n + 9) {
  border-bottom: none;
}
.z_detail_vue .z_detail .z_content {
  width: 100%;
  color: #262626;

  border-radius: 2px;
}
.querytext{
  outline: unset;
  height: 32px;
  line-height: 32px;
  padding: 0 12px;
  display: inline-block;
  border-radius: 2px 0px 0px 2px;
  border: 1px solid rgba(255, 255, 255, 0);
  border-right: 0;
  vertical-align: text-top;
  background: rgba(255, 255, 255, 0.85);
  -webkit-backdrop-filter: saturate(180%) blur(20px);
  backdrop-filter: saturate(180%) blur(20px);
  /* box-shadow: 0px 0px 12px 0px rgb(210 210 210); */
  transition: all 0.3s;
  border-color: #666;
}
.querybtn{
  width: 86px;
  height: 32px;
  line-height: 32px;
  font-size: 16px;
  display: inline-block;
  text-align: center;
  border-radius: 0 2px 2px 0;
  color: #fff;
  background: linear-gradient(200deg, #0050b3 0%, #096dd9 100%);
  vertical-align: text-top;
  cursor: pointer;
  /* box-shadow: 0px 4px 16px 0px rgb(24 14 255 / 20%); */
  position: relative;
}
</style>